/**
 * Created by Ning Jiang on 10/10/2018.
 */

import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { WinCounter } from "../../independent/countup/WinCounter";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { SanBetWayWinData, SanParsedGameData } from "../../../server/data/SanParsedGameData";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { RevealerManager } from "../../independent/revealer/RevealerManager";
import { Revealer } from "../../independent/revealer/Revealer";
import { ParticlesManager } from "../../independent/particles/ParticlesManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { WinAnimation } from "../../independent/winAnimations/WinAnimation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { XWaysCounter } from "../../independent/countup/XWaysCounter";
import { SoundConfig } from "../../../SoundConfig";
import { GameSetting } from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SanGameModuleConfig} from "../../../SanGameModuleConfig";
import { SanQuentin } from "../../../SanQuentin";

class WinState extends StateHandler {
    public static readonly WIN: string = "win";
    public static readonly SMALL_WIN: string = "small_win";
    public static readonly NORMAL: string = "normal";
    public static readonly BIGWIN: string = "bigwin";
    public static readonly DONE: string = "done";
}

export class NormalWinPresentation extends Presentation {

    private _gameData: SanParsedGameData;
    private _winState: WinState = new WinState();

    private winAmount: number = 0;

    private clickAble: boolean = false;
    private clicked: boolean = false;
    private bigWin: boolean = false;
    private winIndx: number = 0;
    private isFs: boolean = false;

    private winConfigDurr: number = 0;
    private lastNormalIndex: number = 0;
    private totalWinWays: number = 0;

    private miniWin:boolean = false;

    private static winAnims: WinAnimation;

    public static get winAnim(): WinAnimation {
        return this.winAnims;
    }

    public checkForActivation(data: SanParsedGameData): boolean { return !!data.singleWin; }

    public initialization(): void {
        NormalWinPresentation.winAnims = new WinAnimation();
        this.lastNormalIndex = SanGameConfig.instance.WIN_RATIOS.normalWin.length - 1;
    }

    public setParsedGamedData(data: SanParsedGameData): void {
        this._gameData = data;

        this._winState.set(WinState.WIN);
        this.bigWin = data.isRealBigwin;

        this.winAmount = !this.bigWin ? data.singleWin : data.playedBetValue * SanGameConfig.instance.WIN_RATIOS.bigWin[0].ratio;

        this.isFs = data.mode === GameMode.FREESPIN;

        this.totalWinWays = data.allWinData.totalWinCombination;

        if (!data.isRealBigwin){
            this.winIndx = SanGameConfig.instance.WIN_RATIOS.normalWin.findIndex((indx) => indx.ratio == data.currentWinRatioConfig?.ratio);
            if(this.winIndx == -1) this.winIndx = 3;
        }
        else
            this.winIndx = this.lastNormalIndex;

        // #241
        SanGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));

        this.miniWin = (this.winIndx <= 1 || SanGameConfig.instance.WIN_BELOW_STAKE);

        this.winConfigDurr = SanGameConfig.instance.WIN_RATIOS.normalWin[this.winIndx].duration + (this.bigWin ? 0.3 : 0);
    }

    preStart():void{ this.clicked = false;}

    public getPresentation(): void {
        this.clickAble = false;
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        switch (this._winState.state) {
            case WinState.WIN:
                this.winPositions();
                this._winState.set(SanGameConfig.instance.WIN_BELOW_STAKE ? WinState.DONE : WinState.NORMAL);
                break;
            case WinState.NORMAL:
                this.addWinCountUpToTimeline();
                break;
            default:
                const isTotal:boolean = this._gameData.totalWin != this._gameData.singleWin;
                if(!this.bigWin)
                    SlotGame.keypad.setWin(isTotal ? this._gameData.totalWin : this._gameData.singleWin, isTotal, SanGameModuleConfig.featurePrice.isWinBelowStake());
                if (this.isFs && !this.bigWin){
                    this.pTimeline.to(this, 0.3, {});
                }
                this.PresentationState.set(PresentationState.INACTIVE);
                break;
        }
    }

    protected winPositions(): void {
        this.clickAble = true;
        XWaysCounter.instance.setValue(undefined,this._gameData.rawData.totalWays,0.25);
         
        this._winState.set(WinState.NORMAL);

        const winGrps: SanBetWayWinData[] = this._gameData.sanBetWays!;
        this.defineNonWin();

        if(!SanGameConfig.instance.WIN_BELOW_STAKE && winGrps.length == 1) return;

        if ((this.winIndx && winGrps.length == 1 && !SlotGame.api.gameClientConfiguration.displayIndividualWinsInGame)) {
            return;
        }
        
        const delay: number = this.miniWin ? 0.15/2 : 0.15;

        let showMiniText: boolean = false;
        const quickSpin:number = GameSetting.isFastSpin ? 0.25 : 0.35;
        const duration: number = this.miniWin ? quickSpin/2 : quickSpin;
        this.pTimeline.to(this, delay + winGrps.length * duration, {},0);

        for (let groups = 0; groups < winGrps.length; groups++) {
            const winData: SanBetWayWinData = winGrps[groups];
            showMiniText = !SlotGame.api.gameClientConfiguration.belowStakeWinRestriction;
            for (let reel = 0; reel < winData.reelWinPositions.length; reel++) {
                let posRow: boolean[] = winData.reelWinPositions[reel];
                let doubleExpWin: boolean = this.isDoubleExpWin(reel, posRow);

                for (let row = 0; row < posRow.length; row++) {
                    if (posRow[row]) {
                        if (row == 0 || row == posRow.length - 1) {
                            const bar: Revealer = row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                            this.pTimeline.add([
                                () => bar.winAnimation(duration, winData.winLvl),
                            ], delay + groups * duration)

                            if(showMiniText && reel == winData.length-1){
                                this.pTimeline.add([
                                    () => bar.hintValue(winData.amount,winData.numberOfCombinations),
                                ], delay + groups * duration)
                            }

                        } else if (!doubleExpWin) {

                            this.pTimeline.add(
                                () => SanEngineManager.getReel(reel).getSymbol(row - 1)!.changeState(
                                { state: ReelSymbolStates.WIN, duration: duration, type: winData.winLvl })
                            , delay + groups * duration);
                            if (showMiniText && reel == winData.length - 1 && !SanGameConfig.instance.WIN_BELOW_STAKE) {
                                this.pTimeline.add(() => { 
                                    SanEngineManager.getReel(reel).getSymbol(row - 1)!.hintValue(winData.amount,winData.numberOfCombinations)
                                }, delay + groups * duration);
                                showMiniText = false;
                            }
                        }
                    }
                }
            }
            this.pTimeline.add(
                () => {
                    if (!this.clicked && !SanGameConfig.instance.WIN_BELOW_STAKE) { // #241
                        SoundManager.playSoundEffect(SoundConfig.instance.HIGHLIGHTWIN_LVL[winData.winLvl]);
                    }
                }
            , delay + groups * duration);
        }
        if(!SlotGame.api.gameClientConfiguration.belowStakeWinRestriction)
            this.pTimeline.to(this,0.2,{});
        // this.pTimeline.to(this,duration/6,{});
    }

    private defineNonWin():void{
        for (let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length; reel++) {
            let posRow: boolean[] = this._gameData.allWinData.reelWinPositions[reel];
            for (let row = 0; row < posRow.length; row++) {
                const toAlpha:number = posRow[row] ? 0 : (this.isFs ? 0.6 : this.miniWin ? 0.3 : 0.4);
                if ((row == 0 || row == 4) && this._gameData.rawData.topRowOpened[reel]){
                    const bar: Revealer = row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel);
                    bar.attentionDarkness(toAlpha,0.2);
                }
                else{
                    if(!SanEngineManager.getReel(reel).getSymbol(row - 1)!.isWild && ! SanEngineManager.getReel(reel).getSymbol(row - 1)!.isJumpWild)
                        SanEngineManager.getReel(reel).getSymbol(row - 1)!.attentionDarkness(toAlpha,0.2);
                }
            }
        }
    }

    public stopPresentation(): void {
        if (!this.bigWin) {
            if(this.clicked)
                WinCounter.normalCounter.abort(undefined,this.totalWinWays,0.25,0.4);
            else{
                WinCounter.normalCounter.abort(undefined,this.totalWinWays);
            }
            
            SanEngineManager.RSAll((reel: number, row: number) => {
                SanEngineManager.getReel(reel).getSymbol(row)?.attentionDarkness(0,0.25);
            })
            RevealerManager.getAllBars().forEach(b => b.attentionDarkness(0,0.25));
        }else{
            WinCounter.normalCounter.stopCounter();
            WinCounter.normalCounter.setValue(this.winAmount);
        }
    }

    private isDoubleExpWin(reelPos: number, row: boolean[]): boolean {
        const revExpanded: boolean = RevealerManager.getTopBar(reelPos).isExpanded && RevealerManager.getBotBar(reelPos).isExpanded;
        const hits: boolean = row[0] && row[row.length - 1];

        return revExpanded && hits;
    }

    protected addWinCountUpToTimeline(): void {
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));

        this.clickAble = true;

        let countUpDuration: number = this.winConfigDurr;
        let animDuration: number = this.miniWin ? 0.3 : 0.75;

        this.pTimeline.add(WinCounter.normalCounter.getCountUpAnimation(0, this.winAmount, countUpDuration, this.miniWin ? 0 : this.winIndx,false,this.bigWin));
        this.pTimeline.add(() =>
        {
            // #241
            if(!this.isFs && !this.bigWin && !SanGameConfig.instance.WIN_BELOW_STAKE) SoundManager.playNormalWinFade();
            SoundManager.stopSoundEffect(SoundConfig.instance.WIN_COUNT);
            NormalWinPresentation.winAnims.winLvlAnimation(this.winIndx);
            WinCounter.normalCounter.bounceHit(this.bigWin ? 6 : this.miniWin ? 0.1 : 2, this.miniWin ? 0.15 : 0.3,true);
            if (!this.bigWin){
                const isTotal:boolean = this._gameData.totalWin != this._gameData.singleWin;
                SlotGame.keypad.setWin(isTotal ? this._gameData.totalWin : this._gameData.singleWin, isTotal, SanGameModuleConfig.featurePrice.isWinBelowStake());
                WinCounter.normalCounter.showWaysWon(this.totalWinWays, 0.5);
                // #241
                !SanGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(SoundConfig.instance.WIN_LVL[this.winIndx])
            } 
            this.winIndx > 2 ? ParticlesManager.normalParticles.enableEmit(true) : {};
        });
        // Start Wins
        for (let reel = 0; reel < this._gameData.allWinData.reelWinPositions.length; reel++) {
            let posRow: boolean[] = this._gameData.allWinData.reelWinPositions[reel];
            let doubleExpWin: boolean = this.isDoubleExpWin(reel, posRow);

            for (let row = 0; row < this._gameData.allWinData.reelWinPositions[reel].length; row++) {
                if (this._gameData.allWinData.reelWinPositions[reel][row]) {
                    if (row == 0 || row == this._gameData.allWinData.reelWinPositions[reel].length - 1) {
                        (row == 0 ? RevealerManager.getTopBar(reel) : RevealerManager.getBotBar(reel)).winAnimation(animDuration,this.winIndx);
                    }
                    else if (!doubleExpWin) {
                        SanEngineManager.getReel(reel).getSymbol(row - 1)!.changeState(
                            { state: ReelSymbolStates.WIN, duration: animDuration, type: this.winIndx });

                    }
                }
            }
        }

        // #241
        !SanGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playSoundEffect(SoundConfig.instance.HIGHLIGHTWIN_LVL[this.winIndx]);

        // Reset and remove blackness.
        const longest: number = Math.max(countUpDuration, animDuration);// + ( !this.bigWin && this.winIndx > 1 ? 0.5 : 0);
        this.pTimeline.to(this, longest, {}, 0);

        this._winState.set(WinState.DONE);
    }

    public skipPresentation(): void {
        if (this.clickAble) {
            if(this.bigWin) SoundManager.stopSoundEffect(SoundConfig.instance.BIG_WIN_INIT_COUNTUP);
            this.clickAble = false;
            this.clicked = true;
            this.pTimeline.totalProgress(1);
        }
    }
}